// Modale Abonnement
// Ouvrir la modale
function mmOpenInfoDelivery() {
  const modalSurface = document.querySelector(".mm-surface-modale-delivery");
  modalSurface.classList.add("mm-visible");
  document.querySelector("html").classList.add("stop-scrolling");
}
// Fermer la modal
function mmCloseInfoDelivery() {
  const modalSurface = document.querySelector(".mm-surface-modale-delivery");

  document.querySelector('html').classList.remove('stop-scrolling');
  modalSurface.classList.remove("mm-visible");
}

// RC Custom Select
function mmRcCustomSelectOpen() {
  const filters = document.querySelectorAll('.mm-product-rc-abo-options-filter');
  filters.forEach(function(filter) {
    filter.classList.add('mm-visible');
  })
}

function mmRcCustomSelectClose() {
  const filters = document.querySelectorAll('.mm-product-rc-abo-options-filter');
  filters.forEach(function(filter) {
    filter.classList.remove('mm-visible');
  })
}

function mmRcCustomSelectChangeValue(clickedOption) {
  const filters = document.querySelectorAll('.mm-product-rc-abo-options-filter');
  filters.forEach(function(filter) {
    filter.classList.remove('mm-visible');
  })

  const selectNames = document.querySelectorAll('.mm-product-rc-abo-selected-option-title');
  selectNames.forEach(function(selectName) {
    selectName.innerText = clickedOption.innerText;
  })
}

// CTA sticky
function mmStickyCtaToggleVariantSelector() {

  // Filter
  const filter = document.querySelector('.mm-sticky-cta-filter');
  filter.classList.toggle('mm-visible');

  // Top title
  const top = document.querySelector('.mm-product-sticky-cta-top');
  top.classList.toggle('mm-activated');

  // Accordeon
  const accordeonContent = document.querySelector('.mm-sticky-cta-accordeon-content');
  const accordeonInner = document.querySelector('.mm-sticky-cta-accordeon-inner');
  if(top.classList.contains('mm-activated')) {
    accordeonContent.style.maxHeight = accordeonInner.offsetHeight + 'px';
  } else {
    accordeonContent.style.maxHeight = '0px';
  }
}



/**
 * Initialize the sticky CTA behavior.
 */
function initStickyCTA() {
    const classicCTA = document.querySelector(".mm-main-product-cta");
    const stickyCTAs = document.querySelectorAll("[data-sticky-cta]");

    if (!classicCTA || stickyCTAs.length === 0) {
        console.log("CTA elements not found:", { classicCTA, stickyCTAs });
        return;
    }

    function toggleStickyCTA() {
        const classicCTARect = classicCTA.getBoundingClientRect();
        const isDesktop = window.matchMedia('(min-width: 769px)').matches;
        const isAtBottom = (window.innerHeight + window.scrollY) >= document.body.offsetHeight;

        let shouldShow;
        if (isDesktop) {
            // Desktop : le sticky n'apparaît qu'une fois le CTA principal DÉPASSÉ
            // (entièrement scrollé au-dessus du viewport), pas avant de l'avoir atteint.
            const hasScrolledPastClassicCTA = classicCTARect.bottom <= 0;
            shouldShow = hasScrolledPastClassicCTA && !isAtBottom;
        } else {
            // Mobile : comportement d'origine (sticky dès que le CTA principal n'est pas visible).
            const isClassicCTAVisible = classicCTARect.bottom > 0 && classicCTARect.top < window.innerHeight;
            shouldShow = !isAtBottom && !isClassicCTAVisible;
        }

        const stickyTop = document.querySelector('.mm-product-sticky-cta-top');
        const optionsOpened = stickyTop && stickyTop.classList.contains('mm-activated');

        stickyCTAs.forEach(stickyCTA => {
            if (shouldShow) {
                stickyCTA.classList.remove("mm-hidden");
            } else if (!optionsOpened) {
                stickyCTA.classList.add("mm-hidden");
            }
        });
    }

    // Initial check
    toggleStickyCTA();

    // Listen for scroll events
    window.addEventListener("scroll", () => {
        toggleStickyCTA();
    });
}

function initFicheTabs() {
	document.addEventListener("click", (event) => {
		const tab = event.target.closest("[data-fiche-tab]");
		if (!tab) return;
		const root = tab.closest("[data-fiche-tabs]");
		if (!root) return;
		const key = tab.dataset.ficheTab;
		if (event.detail > 0) tab.blur();
		root.querySelectorAll("[data-fiche-tab]").forEach((item) => {
			const active = item === tab;
			item.classList.toggle("is-active", active);
			item.setAttribute("aria-selected", active ? "true" : "false");
		});
		root.querySelectorAll("[data-fiche-panel]").forEach((panel) => {
			panel.classList.toggle("is-active", panel.dataset.fichePanel === key);
		});
		const bar = tab.parentElement;
		const barRect = bar.getBoundingClientRect();
		const tabRect = tab.getBoundingClientRect();
		if (tabRect.left < barRect.left) {
			bar.scrollBy({ left: tabRect.left - barRect.left, behavior: "smooth" });
		} else if (tabRect.right > barRect.right) {
			bar.scrollBy({ left: tabRect.right - barRect.right, behavior: "smooth" });
		}
	});
}

document.addEventListener("DOMContentLoaded", () => {
	initStickyCTA();
	initFicheTabs();
});


/*********************************************************************************************
* Class for handling variant selection
	*
*/
class VariantSelector extends HTMLElement {
	constructor() {
		super();
		this.cached = {};
		this.container = this.closest("#product-form");
		this.addEventListener("change", this.onVariantChange);
	}

	/*********************************************************************************************
	* Handle variant change event.
		*
	*/
	onVariantChange() {
		this.getSelectedOptions();
		this.getSelectedVariant();

		if (this.currentVariant) {
			this.updateURL();
			if (this.dataset.imageVariant) {
                this.updateImagesVariant();
            } else {
                this.updateMedia();
            }
            this.variantFetch();
		}
	}

	/*********************************************************************************************
	* Get selected options from the variant checkboxes.
		*
	*/
	getSelectedOptions() {
		this.options = Array.from(this.querySelectorAll(".mm-product-variant-checkbox:checked"), (checkbox) => checkbox.value);
	}

	/*********************************************************************************************
	* Get variant data from the embedded JSON.
		*
		* @returns {Object} - The variant data.
	*/
	getVariantJSON() {
		this.variantData = JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}

	/*********************************************************************************************
	* Get the selected variant based on selected options.
		*
	*/
	getSelectedVariant() {
		this.currentVariant = this.getVariantJSON().find((variant) => {
			const findings = !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);

			if (findings) return variant;
		});
	}

	/*********************************************************************************************
	* Update the URL to include the selected variant ID.
		*
	*/
	updateURL() {
        window.history.replaceState({}, "", `${this.dataset.url}?variant=${this.currentVariant.id}`);
	}

	/*********************************************************************************************
	* Fetch variant data from the server and cache it.
		*
	*/
	variantFetch() {
		var variantUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;

		if (this.cached[variantUrl]) {
			this.renderVariantInfo(this.cached[variantUrl]);
            this.updateRCselector();
			return;
		}

		fetch(variantUrl)
			.then((response) => response.text())
			.then((responseText) => {
				const html = new DOMParser().parseFromString(responseText, "text/html");
				this.cached[variantUrl] = html;
				this.renderVariantInfo(html);
				this.updateRCselector();
			})
			.catch((e) => {
				console.error(e);
			});
	}

	/*********************************************************************************************
	* Render variant information in the DOM.
		*
		* @param {Document} html - The HTML document containing the variant information.
	*/
	renderVariantInfo(html) {
		this.updateElementOuter("#product_id", html);
		this.updateElementOuter(".mm-product-form-component-title", html);
		this.updateElementOuter(".mm-product-price", html);
		this.updateMultipleElement(".mm-product-form-variant-value", html);
		this.updateMultipleElement(".mm-reload", html);
		this.updateElementOuter(".mm-product-cta", html);
		this.updateImagesVariant();
	}

	/*********************************************************************************************
	* Update the inner HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElement(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.innerHTML = source.innerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of an element.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateElementOuter(selector, html) {
		const destination = this.container.querySelector(selector);
		const source = html.querySelector(selector);
		if (source && destination) destination.outerHTML = source.outerHTML;
	}

	/*********************************************************************************************
	* Update the outer HTML of multiple elements.
		*
		* @param {string} selector - The CSS selector of the element to update.
		* @param {HTMLElement} html - The HTML element containing the new content.
	*/
	updateMultipleElement(selector, html) {
        const destination = document.querySelectorAll(selector);
        const source = html.querySelectorAll(selector);

        if (source && destination) {
            for (let index = 0; index < source.length; index++) {
                destination[index].outerHTML = source[index].outerHTML;
            }
        }
    }

	/*********************************************************************************************
	* Update the media carousel to display the featured media of the current variant.
		*
	*/
	updateMedia() {
        if (this.currentVariant && this.currentVariant.featured_media) {
            var variant_media_id = this.currentVariant.featured_media.id;
            var allMainMedia = document.querySelectorAll(".mm-product-medias .splide__slide");

            allMainMedia.forEach((media, index) => {
                if (media.dataset.id != null && parseInt(media.dataset.id) == variant_media_id) {
                    //splideMainInstance.go(index);
                }
            });
        }
    }

	/*********************************************************************************************
	* Update the visibility of the media sliders for the current variant.
		*
	*/
	updateImagesVariant() {
        var allMainMedia = document.querySelectorAll(".main-slider-variant");
        allMainMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
        var allThumbnailMedia = document.querySelectorAll(".thumbnail-slider-variant");
        allThumbnailMedia.forEach((media) => {
            if (media.dataset.variantid == this.currentVariant.id) {
                media.style.display = "flex";
            } else {
                media.style.display = "none";
            }
        });
    }

	updateRCselector() {
		const checked_plan = document.querySelector('.mm-selling-plans-elem input:checked');
		console.log('checked_plan', checked_plan)
		if(checked_plan) {
			const changeEvent = new Event("change");
			checked_plan.dispatchEvent(changeEvent);
		}
	}
}

/*********************************************************************************************
* Define the custom element
	*
*/
customElements.define("variant-selector", VariantSelector);
